import { jsPDF } from 'jspdf';
import JsBarcode from 'jsbarcode';
import _ from 'lodash';

// convert orderNo to base64Barcode
// convert base64Barcode to PNGImage
// Use PNGImage in pdf downloaded file
const generateAndDownloadBarcodeInPDF = (barcodes, pageWidth, pageHeight, pageRealHeight, pageType,itemsPerPage) => {
	const imgHeight = pageRealHeight;
	const imgWidth = Math.floor(pageWidth / itemsPerPage);
	let topMargin = 10;
	switch (pageType) {
		case 'TEM_2_10070':
			topMargin = 90;
			break;
		default:
			topMargin = 10;
			break;
	}

	const pdf = new jsPDF({ orientation: 'landscape', unit: 'pt', format: [pageWidth, pageHeight] }); //366,200
	for (let i = 0; i < barcodes.length; i++) {
		const x = i%itemsPerPage == 0 ? 0:  imgWidth * (i%itemsPerPage);

		let img = new Image();
		
		img.src = convertTextToBase64Barcode(barcodes[i], imgHeight, topMargin);
		img.onload = function() {
			if (i > 0 && (i  % itemsPerPage) == 0) {

				pdf.addPage();
			}
			pdf.addImage(img, 'PNG', x, 0, imgWidth, imgHeight, null, 'NONE');
			if (i == barcodes.length - 1) {
				pdf.save('barcode.pdf');
			}
		};
	}
};
const convertTextToBase64Barcode = (text, height, topMargin) => {
	let canvas = document.createElement('canvas');
	JsBarcode(canvas, text, {
		format: 'CODE128',
		height: height,
		width: 1,
		fontSize: 25,
		font: 'Arial',
		marginTop: topMargin,
		marginLeft: 10,
		marginRight: 10,
	});
	return canvas.toDataURL('image/png');
};
export { generateAndDownloadBarcodeInPDF };
